// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_DOMAIN } from './select-domain.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_DOMAIN);

export const selectDomainListResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectDomainListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectDomainListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


